import { useOutletContext, useParams } from "react-router-dom";
import AttendanceTable from "./_components/AttendanceTable";
import type { EventOutletContext } from "../_layout";

export default function AttendancePage() {
  const { eventSlug = "" } = useParams();
  const { eventData } = useOutletContext<EventOutletContext>();
  const multiSession = eventData?.sessionCount && eventData.sessionCount > 1;

  return (
    <div data-testid="registrants-page">
      <AttendanceTable eventSlug={eventSlug} multiSession={multiSession || false} />
    </div>
  );
}
